import React, { useEffect } from 'react';

export function SplashScreen({ onComplete }) {
  useEffect(() => {
    const timer = setTimeout(onComplete, 2500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen bg-darker flex flex-col items-center justify-center relative overflow-hidden">
      <div 
        className="absolute w-64 h-64 rounded-full opacity-20"
        style={{
          background: 'radial-gradient(circle, rgba(212,175,55,0.4) 0%, transparent 70%)',
          top: '50%', left: '50%', transform: 'translate(-50%, -70%)'
        }}
      />
      <div className="relative z-10 mb-6" style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{
          width: '100px', height: '100px', borderRadius: '20px', background: '#1a1a1a',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 4px 30px rgba(212,175,55,0.3)', padding: '12px'
        }}>
          <img src="/images/hiwaytrip-icon.png" alt="HiWayTrip" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
      </div>
      <h1 className="text-4xl font-bold tracking-wider relative z-10"
        style={{ fontFamily: "'Manrope', sans-serif", background: 'linear-gradient(135deg, #D4AF37 0%, #F5ECD8 50%, #D4AF37 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
        HiWayTrip
      </h1>
      <p className="mt-3 text-subtle-dark text-sm tracking-wide relative z-10">Your Premium Highway Companion</p>
      <div className="mt-16 relative">
        <div className="w-10 h-10 rounded-full animate-spin" style={{ border: '2px solid rgba(212,175,55,0.2)', borderTopColor: '#D4AF37' }} />
      </div>
    </div>
  );
}

export default SplashScreen;
